import ArticleTemplate from '@/pages/article/components/ArticleTemplate';

export default function ArticleAlternatives() {
  return <ArticleTemplate slug="sugargoo-alternatives" />;
}